import { 
	intervalToDuration,
	startOfYear,
	addYears,
	startOfMonth,
	addMonths,
	startOfDay,
	addDays,
	getTime
} from 'date-fns'

const suggest_range = (start_date, end_date) => {
    const { years, months, days, hours } = intervalToDuration({
		start: start_date,
		end: end_date
	});
	
	let next_start_date = start_date;
	let next_end_date = end_date;
	
	if( years > 1 ) {
		next_start_date = startOfYear(start_date);
		next_end_date = startOfYear(addYears(end_date, 1));
	} else if( months > 0 ) {
		next_start_date = startOfMonth(start_date);
		next_end_date = startOfMonth(addMonths(end_date, 1));
	} else {
		next_start_date = startOfDay(start_date);
		next_end_date = startOfDay(addDays(end_date, 1));
	}
		
	const timeMin = getTime(next_start_date);
	const timeMax = getTime(next_end_date);
	
	return {
		min: timeMin,
		max: timeMax
	}
}

export {
	suggest_range
}